import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';
import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const addNewProtectorsOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  sessionId: number,
  lecturesIds: { userId: number; activityTypeId: number; classId: number }[],
  setExamDetails: (sessions: ExamSessionDetails[]) => any,
  onHide: () => any,
) => {
  try {
    if (!programId || !courseId) {
      toast.warn(
        'לא ניתא לאתר את מזהה התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }
    const res = await appApi.addExamProtector(
      programId,
      courseId,
      examId,
      sessionId,
      lecturesIds,
    );

    setExamDetails(res.data.body);
    toast.success('הוספת המשגיחים בתהצעה בהצלחה');

    onHide();
  } catch (e) {
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים...');
  }
};
